import { emitFieldClosedEvent } from 'app/events';

export const closeElement = (element: string, options?: { [key: string]: any }) => {
  setTimeout(() => {
    const active = document.activeElement;

    const contains = !document.getElementById('search-mask-component')?.contains(active);
    const expanded = active?.hasAttribute('aria-expanded');
    const falseExpanded = active?.getAttribute('aria-expanded') === 'false';

    if (contains || !expanded || (expanded && falseExpanded)) {
      emitFieldClosedEvent(element, options);
    }
  }, 100);
};
